import 'babel-polyfill'  
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VueSilentbox from 'vue-silentbox'
import WOW from 'wow.js/dist/wow.js';

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

Vue.use(VueSilentbox)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(VueResource)




// Tailwind
import '@/assets/css/main.css'

// Styles: SCSS
 import './assets/scss/main.scss'

// Styles: SCSS CARD
 import './assets/scss/card.scss'

 import 'bootstrap/dist/css/bootstrap.css'
 import '../src/assets/css/fontawesome-all.min.css'
 import 'swiper/dist/css/swiper.css'
 import 'animate.css/animate.min.css'
 import '../src/assets/scss/style.scss'
 import 'slick-carousel/slick/slick.css'



import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';


import VueAnalytics from 'vue-analytics'
//import VueYandexMetrika from 'vue-yandex-metrika'
// i18n
import i18n from './i18n/i18n'

Vue.config.productionTip = false
Vue.config.productionSourceMap = false
Vue.config.devtools = true
Vue.config.performance = true

//import { routes } from './router/index'

// Vue Router
import router from './router/index'

// const router = new VueRouter({
//     routes,
//     mode: 'history',
//     base: process.env.BASE_URL,
//     scrollBehavior() {document.getElementById('app').scrollIntoView();}
// })
//tawk chat
import Tawk from 'vue-tawk'
Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/5ac205804b401e45400e43d0/default'
})
// Vue.use(VueYandexMetrika, {
//     id: 21166324,
//     router: router,
//     env: process.env.NODE_ENV
//     // other options
//   })
Vue.use(VueAnalytics, {
    id: 'UA-37236566-1',
    router 
  })

  // axios
//import axios from './axios.js'
//Vue.prototype.$http = axios

// mock
//import './fake-db/index.js'



// Vuex Store
import store from './store/store'

// Vuexy Admin Filters
import './filters/filters'

// Globally Registered Components
import './globalComponents.js'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Theme Configurations
import '../themeConfig.js'


// Firebase
 import '@/firebase/firebaseConfig'


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')



// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

//change pagetitle
router.beforeEach((to, from, next) => {
    if (to.meta.pageTitle != null){
      document.title = i18n.t(to.meta.pageTitle)
    }
    
    next()
  })

// Vue.http.options.credentials = true;

// Vue.http.options.xhr = {
//   withCredentials: true 
// }
// Vue.http.options.emulateJSON = true
// Vue.http.options.emulateHTTP = true
// Vue.http.options.crossOrigin = true

// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
// Vue.http.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
// Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*'
// Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'
// {{ purchase | currecny}}
Vue.filter("currency", (value) => {
  return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits : 2})
})

new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    template: '<App/>',
    //components: { App },
    i18n,
    mounted(){
        new WOW().init();
    }
}).$mount('#app')
